import { Parameter } from '../../types/SetpointManagerTypes';
import ControllerValueDropdown from '../ControllerValueDropdown';
import TextInput from '../filter-modal/TextInput';
import { ArrowUturnLeftIcon } from '@heroicons/react/24/outline';
import { useAppDispatch, useAppSelector } from '../../hooks/storeHooks';
import { addWriteItem, removeWriteItem } from '../../features/setpoints-manager/parameterGroupsSlice';

interface EditableCellProps {
  parameter: Parameter;
}

const EditableCell: React.FC<EditableCellProps> = ({ parameter }) => {
  const readItems = useAppSelector((state) => state.parameterGroups.readItems);
  const writeItems = useAppSelector((state) => state.parameterGroups.writeItems);
  const dispatch = useAppDispatch();
  const handleInputChange = (value: string) => {
    dispatch(addWriteItem({ [parameter.parameter]: value }));
  };
  const handleDropdownChange = (value: string) => {
    dispatch(addWriteItem({ [parameter.parameter]: value }));
  };
  const resetValue = () => {
    dispatch(removeWriteItem(parameter.parameter));
  };
  const writeVal = writeItems[parameter.parameter];
  const hasValue = writeVal !== undefined && writeVal !== String(parameter.currentValue);
  return (
    <div className='parameter-table__controller-value'>
      <div className='flex items-center w-full justify-between'></div>
      <div className='flex items-center parameter-table__data-text--muted' style={{ flex: 1 }}>
        {readItems[parameter.parameter] ? (
          parameter?.backUpLookUpValues?.length ? (
            <div className='flex items-center w-full parameter-table__input-container'>
              <ControllerValueDropdown
                options={parameter.backUpLookUpValues}
                onChange={handleDropdownChange}
                buttonText='View options'
                className={`w-full ${writeVal === '' ? 'error' : hasValue ? 'written' : ''}`}
                value={writeVal ?? String(parameter.currentValue)}
              />
              <div className='ml-2'>
                {hasValue ? (
                  <ArrowUturnLeftIcon className='h-6 w-6 text-white' onClick={resetValue} />
                ) : (
                  <div className='w-6 h-6' />
                )}
              </div>
            </div>
          ) : (
            <div className='flex items-center w-full parameter-table__input-container'>
              <TextInput
                onChange={(e) => handleInputChange(e)}
                placeholder=''
                value={writeVal !== undefined ? writeVal : String(parameter.currentValue || '')}
                className={`w-full parameter-table__input-field ${writeVal === '' ? 'error' : hasValue ? 'written' : ''}`}
              />
              <div className='ml-2'>
                {hasValue ? (
                  <ArrowUturnLeftIcon className='h-6 w-6 text-white' onClick={resetValue} />
                ) : (
                  <div className='w-6 h-6' />
                )}
              </div>
            </div>
          )
        ) : (
          <span className='parameter-table__data-text truncate' style={{ maxWidth: '100%' }}>
            {parameter.currentValue || '-'}
          </span>
        )}
      </div>

      <div style={{ marginLeft: 8, minWidth: 60 }} className='parameter-table__data-text--right'>
        {parameter.uom ? `(${parameter.uom})` : ''}
      </div>
    </div>
  );
};
export default EditableCell;
